import { ReactLenis } from '@studio-freight/react-lenis';
import Router from './pages/route/Router';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
    <ReactLenis
      root
      options={{ gestureOrientation: "both", smoothWheel: true }}
    >
      <div className="App">
        <Router />
      </div>
    </ReactLenis>
    </HelmetProvider>
  );
}

export default App;
